import { Roles } from '@/auth/azure/Roles'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import { ExpensesPageRoute } from '@/routes/expenses/ExpensesPage.route'
import { HoursPageRoute } from '@/routes/hours/HoursPage.route'
import WorkActivitiesPage from '@/routes/workactivities/WorkActivitiesPage'
import { RoleRoute } from '@/types'
import { faClock } from '@fortawesome/free-solid-svg-icons'
import { redirect } from 'react-router-dom'

export const workActivitiesPageSubRoutes: RoleRoute[] = [
  {
    index: true,
    loader: () => redirect('hours'),
    visible: false,
    allowedRoles: [
      Roles.GlobalAdministrator,
      Roles.Administrator,
      Roles.Marketing,
      Roles.TechDeveloper,
      Roles.Sales,
      Roles.Supervisor,
    ],
  },
  HoursPageRoute,
  ExpensesPageRoute,
]

export const WorkActivitiesPageRoute: RoleRoute = {
  path: 'workactivities',
  element: <WorkActivitiesPage />,
  errorElement: <RouterErrorHandler />,
  children: workActivitiesPageSubRoutes,
  mainMenuRoute: true,
  text: 'Ore',
  faIcon: faClock,
  handle: {
    crumb: () => ({
      label: 'Attività Lavorative',
      icon: faClock,
    }),
  },
  allowedRoles: [
    Roles.GlobalAdministrator,
    Roles.Administrator,
    Roles.Marketing,
    Roles.TechDeveloper,
    Roles.Sales,
    Roles.Supervisor,
  ],
}
